const SLIDE_FRAME_MIN = 1;
const SLIDE_FRAME_MAX = 9;

export function slidePrecedentImageSrc(slideFrameId: number): string {
  return `assets/slides/${encodeURIComponent(`Slide${slideFrameId}.PNG`)}`;
}

export function slidePrecedentImageSrcOrNull(slideFrameId: number | null | undefined): string | null {
  if (!slideFrameId || slideFrameId < SLIDE_FRAME_MIN || slideFrameId > SLIDE_FRAME_MAX) {
    return null;
  }
  return slidePrecedentImageSrc(slideFrameId);
}
